The details of the webhook subscription to be deleted.
